/*
fitBorder will not use the Fabric generated JSON. This is to ensure that any floating point posititions
don't leave gaps around border. I also need to extend the size of the canvas for real border vs inset. 

every fit function must have ability to export as png (aka just the fit watermark) or also composite image
the straight up fit watermark (aka export png) is for applying from upload + pica resize
the composite fit watermark is used when selecting a watermark from sidebar templates
*/

// must use callback if you are doing simpleComposite!
// compositeBackgroundImage and callback are not required by this function
function fitBorder(borderProperties, fontProperties, origWidth, origHeight, newWidth, newHeight, outputType, outputQuality = '96', compositeBackgroundImage, callback) {
  let scaleValue = newWidth/origWidth
  // NEED TO CHECK HERE >>> MULTIPLE CANVAS' ARE EXPENSIVE AND UNNECESSARY >> SHOULD CONSIDER RE-USING !!!!
  
  // instantiate Fabric canvas
  var newCanvas = document.createElement('canvas');
  // explicitly set dimensions to make sure there's no funny business when loading Fabric JSON obj
  newCanvas.width = newWidth
  newCanvas.height = newHeight
  // this is size of the new image... will need to adjust for adding border later
  var fitCanvas = new fabric.StaticCanvas(newCanvas, {width: newWidth, height: newHeight});

  let borderPadding = Math.ceil(borderProperties.borderSize * scaleValue)
  // BORDER TOP   
  if (borderProperties.borderType === 'top') {
      // rescale canvas to include space for border
      fitCanvas.setHeight(newHeight + borderPadding)
      var rect = new fabric.Rect({
          width: newWidth,
          height: borderPadding,
          fill: borderProperties.borderColor,          
          originX: 'left',
          originY: 'top',
      });

      fitCanvas.add(rect);   
  }

  // BORDER TOP-INSET
  if (borderProperties.borderType === 'top-inset') {
      var rect = new fabric.Rect({
          width: newWidth,
          height: borderPadding,
          fill: borderProperties.borderColor,
          opacity: borderProperties.borderOpacity,
          originX: 'left',
          originY: 'top',
          // include stroke for inset so no 1px empty space is left around object
          stroke: borderProperties.borderColor,
          strokeWidth: 1,  
      });
      fitCanvas.add(rect);   
  }

  // BORDER BOTTOM
  if (borderProperties.borderType === 'bottom') {
      fitCanvas.setHeight(newHeight + borderPadding)
      // add rect
      var rect = new fabric.Rect({
          width: newWidth,
          height: borderPadding,
          fill: borderProperties.borderColor,    
          originX: 'left',
          originY: 'top',               
      });

      rect.set('top', newHeight) // simply put rect at bottom of image
      rect.setCoords()                
      fitCanvas.add(rect);     

  }                
  // BORDER BOTTOM-INSET
  if (borderProperties.borderType === 'bottom-inset') {
      var rect = new fabric.Rect({
          width: newWidth,
          height: borderPadding,
          fill: borderProperties.borderColor,
          opacity: borderProperties.borderOpacity,
          originX: 'left',
          originY: 'top',    
          // include stroke for inset so no 1px empty space is left around object
          stroke: borderProperties.borderColor,
          strokeWidth: 1,            
      });


      let temp = newHeight - borderPadding
      rect.set('top', temp)
      rect.setCoords()                         
      fitCanvas.add(rect);                  
  }                
  // BORDER ALL-SIDES
  if (borderProperties.borderType === 'all-sides') {
      fitCanvas.setHeight(newHeight + (2*borderPadding))
      fitCanvas.setWidth(newWidth + (2*borderPadding))
      
      // top
      var rectTop = new fabric.Rect({
          width: fitCanvas.width,
          height: borderPadding,
          fill: borderProperties.borderColor,
          opacity: borderProperties.borderOpacity,
          originX: 'left',
          originY: 'top',       
      });
      fitCanvas.add(rectTop);                  
      // bottom
      var rectBottom = new fabric.Rect({
          width: fitCanvas.width,
          height: borderPadding,
          fill: borderProperties.borderColor,       
      });
      let temp = newHeight + borderPadding // top border + imageHeight
      rectBottom.set('top', temp)
      rectBottom.setCoords()                                
      fitCanvas.add(rectBottom);                           
      // left
      var rectLeft = new fabric.Rect({
          width: borderPadding,
          height: fitCanvas.height,
          fill: borderProperties.borderColor,
      });              
      fitCanvas.add(rectLeft);                              
      // right
      var rectRight = new fabric.Rect({
          width: borderPadding,
          height: fitCanvas.height,
          left: newWidth + borderPadding,
          fill: borderProperties.borderColor,        
      });
      fitCanvas.add(rectRight);                          

  }                
  // BORDER MEME
//  if (borderProperties.borderType === 'meme') {
//      // border top
//      var rect = new fabric.Rect({
//          width: this.canvasWidth,
//          height: this.borderSize(),
//          fill: this.borderColor.hex,
//          opacity: this.borderOpacitySlider.value/100,
//          selectable: false               
//      });
//
//      fitCanvas.add(rect);   
//
//      // add rect bottom
//      var rect2 = new fabric.Rect({
//          width: this.canvasWidth,
//          height: this.borderSize(),
//          fill: this.borderColor.hex,
//          opacity: this.borderOpacitySlider.value/100,
//          selectable: false          
//      });
//
//      let temp = this.canvasHeight - (rect2.height * rect2.scaleY) - 1
//      rect2.set('top', temp)
//      rect2.setCoords()                                
//      fitCanvas.add(rect2);  
//  }   
  
  //
  // TEXT
  //

  if (borderProperties.borderTextTop) {
      //toLowerCase error is because this part fails
      var text = new fabric.IText(borderProperties.borderTextTop, {
          fontSize: fontProperties[0].fontSize * scaleValue,
          fontFamily: fontProperties[0].fontFamily,
          fill: fontProperties[0].fontColor,
          left: 0,
          top: 100,   
      });     
      // set height to middle of rectangle
      text.set('top', (borderPadding - text.height)/2)
      fitCanvas.add(text);   
      // set left / center / right
      if (borderProperties.borderTextPosition === 'left') {
          // nothing
      } else if (borderProperties.borderTextPosition === 'center') {
          text.centerH()                            
      } else if (borderProperties.borderTextPosition === 'right') {
          text.set('left', newWidth - text.width)
      }        
      text.setCoords()   
      fitCanvas.bringToFront(text)                           
  }  

  if (borderProperties.borderTextBottom) {
        var text = new fabric.IText(borderProperties.borderTextBottom, {
            fontSize: fontProperties[0].fontSize * scaleValue,
            fontFamily: fontProperties[0].fontFamily,
            fill: fontProperties[0].fontColor,
            left: 0,
            top: 100,
        });     
      
        // set height to middle of rectangle
        // need 2 for bottom and bottom inset
        if (borderProperties.borderType === 'bottom')  {
            text.set('top', newHeight + (borderPadding - text.height)/2)
        } else if (borderProperties.borderType === 'bottom-inset') {
            text.set('top', (newHeight - borderPadding) + (borderPadding - text.height)/2)
        } else if (borderProperties.borderType === 'all-sides') {
            text.set('top', newHeight + borderPadding + (borderPadding - text.height)/2)
        }

        fitCanvas.add(text);   
        // set left / center / right
        if (borderProperties.borderTextPosition === 'left') {
            // nothing
        } else if (borderProperties.borderTextPosition === 'center') {
            text.centerH()                            
        } else if (borderProperties.borderTextPosition === 'right') {
            text.set('left', newWidth - text.width - 0.01)
        }
        text.setCoords()  
        fitCanvas.bringToFront(text)                                                              
  }  

  fitCanvas.requestRenderAll();  



  var watermark = fitCanvas.toDataURL('image/png', 1)
  var cbk  = callback;
  if (compositeBackgroundImage) {
    fabric.Image.fromURL(compositeBackgroundImage, function(oImg) {
      
      // unfortunately i need to put a lot of logic in here... fabric says when image is ready
      // if it _is_ composite and image ready, i need to slap the image in with respect to the new border
      if (['top','meme'].includes(borderProperties.borderType)) {
        // top, all, and meme need image to be pushed down by the borderPadding amount
        oImg.top = borderPadding;
      } else if (borderProperties.borderType === 'all-sides') {
        oImg.top = borderPadding;
        oImg.left = borderPadding;
      }

      fitCanvas.add(oImg);
      fitCanvas.sendToBack(oImg);
      fitCanvas.renderAll();
      var watermarkComposite = fitCanvas.lowerCanvasEl.toDataURL('image/' + outputType, outputQuality)
      return cbk({watermark, watermarkComposite})
    }, { crossOrigin: 'anonymous' });
  } else if (outputType == 'json') {
    var data = fitCanvas.toJSON();  
    return cbk(data)                    
  } else {             
    var data = fitCanvas.toDataURL('image/png', 1);    
    return cbk(data)               
  }                      
}

export { fitBorder };
